<template>
  <div class="gray-back" style="height: 100%">
    <div class="score-login-box">
      <div class="score-login-logo">
<!--        <img src="https://static.dierqudao.com/images/cca/login-logo.png" alt="">-->
        <img src="../../../assets/images/score/logo2.png" alt="">
      </div>
    </div>
    <div class="score-login-extra">
      <van-cell-group class="score-cell">
        <!--                <van-form @submit="onSubmit">-->
        <!--                    <van-field-->
        <!--                            v-model="formData.name"-->
        <!--                            name="姓名"-->
        <!--                            label=""-->
        <!--                            left-icon="https://static.dierqudao.com/images/cca/login-name.png"-->
        <!--                            clearable-->
        <!--                            placeholder="请输入姓名"-->
        <!--                            :rules="[{ required: true, message: '姓名' }]"-->
        <!--                    />-->
        <van-field
            v-model="formData.id_code"
            name="身份证号"
            :left-icon="require('../../../assets/images/score/login-card.png')"
            clearable
            :readonly="readonly"
            @focus="onFocus"
            placeholder="请输入身份证号"
            :rules="[{ required: true, message: '身份证号' }]"
        />
        <div class="score-button">
          <van-button round block type="info" color="linear-gradient(to right, #72CAF9, #2492FB)" @click="onSubmit" v-if="!saveLoading">
            登录
          </van-button>
          <van-button round block type="info" color="linear-gradient(to right, #65F6D6, #0EB993)" v-else >
            登录中...
          </van-button>
        </div>

        <!-- <div class="check-text" @click="toCheckLogin">我是复核</div> -->
        <!--                </van-form>-->

        <div class="fr flex-start" v-show="formData.id_code == 'X001'">
          <div class="mr10">云上版</div>
          <van-switch v-model="checked"  @change="switchChange" inactive-color="#eee" size="24px"	 />
          <div class="ml10">内网版</div>
        </div>
      </van-cell-group>



    </div>

    <van-action-sheet v-model="show" title="正在进行">
      <van-cell-group>
        <van-cell :title="item.saiqu_name + ' ' +item.title" is-link v-for="(item, index) in list" @click="toScoreCheck(item.id)" />
      </van-cell-group>
    </van-action-sheet>

    <van-number-keyboard
        :show="keyShow"
        extra-key="X"
        close-button-text="完成"
        @close="keyShow = false"
        v-model="formData.id_code"
    />
    <!--        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>-->

  </div>
</template>
<style scoped>
@media screen and (min-width: 768px) {
  .check-text {
    text-align: center;
    padding: .2rem;
    font-size: 16px;
    cursor: pointer;
  }
  .score-login-box {
    /*background: url("https://static.dierqudao.com/images/cca/login-bg.png") no-repeat;*/
    background: url("../../../assets/images/score/login-bg.png") no-repeat;
    /*width: 7.5rem;*/
    /*height: 3.8rem;*/
    background-size: 100% 1.2rem;
    height: 1.2rem;
    position: relative;
  }

  .score-login-box .score-login-logo {
    width: 1.2rem;
    height: 1.2rem;
    box-shadow: 0 1px 20px 0 rgba(28, 140, 250, 0.3);
    border-radius: 10px;
    background: #fff;
    position: absolute;
    bottom: -0.6rem;
    left: 3.15rem;
  }

  .score-login-logo img {
    width: 100%;
    height: 100%;
  }

  .score-login-extra {
    margin: .8rem 0;
  }

  .score-login-extra .score-cell {
    height:1000px;
    padding: 0.5rem 0.5rem 0.8rem;
  }

  .score-login-extra >>> .van-icon__image {
    width: .3rem;
    height: .3rem;
  }

  .score-login-extra >>> .van-field__body input {
    height: .3rem;
    font-size: .2rem;
  }

  .score-login-extra .score-button {
    padding: .2rem 0.4rem 0;
  }
}

@media screen and (max-width: 768px) {
  .check-text {
    text-align: center;
    margin-top: .2rem;
    padding: .2rem;
    font-size: 16px;
    cursor: pointer;
  }
  .score-login-box {
    background: url("../../../assets/images/score/login-bg.png") no-repeat;
    /*width: 7.5rem;*/
    /*height: 3.8rem;*/
    background-size: 100% 3.8rem;
    height: 3.8rem;
    position: relative;
  }

  .score-login-box .score-login-logo {
    width: 1.6rem;
    height: 1.6rem;
    box-shadow: 0 1px 20px 0 rgba(28, 140, 250, 0.3);
    border-radius: 10px;
    background: #fff;
    position: absolute;
    bottom: -0.8rem;
    left: 2.95rem;
  }

  .score-login-extra .score-cell {
    padding:1rem 0.5rem;
  }

  .score-login-extra .score-button {
    padding: 2rem 0.4rem 0;
  }

  .score-login-logo img {
    width: 100%;
    height: 100%;
  }

  .score-login-extra {
    margin-top: 2rem;
  }

  .score-login-extra >>> .van-icon__image {
    width: 28px;
    height: 28px;
  }

  .score-login-extra >>> .van-field__body input {
    height: 28px;
  }
}
</style>
<script>
import Vue from 'vue';

import {
  Cell,
  Field,
  Tag,
  CellGroup,
  Stepper,
  Toast,
  Button,
    Switch,
  NumberKeyboard
} from 'vant';

export default {
  name: 'CommonLogin',
  components: {
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Tag.name]: Tag,
    [Stepper.name]: Stepper,
    [Switch.name]: Switch,
    [NumberKeyboard.name]: NumberKeyboard,
  },
  data: function () {
    return {
      show: false,
      saveLoading: false,
      loginShow: false,
      keyShow: false,
      readonly: true,
      checked: localStorage.getItem('_is_local') == 1 ? true : false,
      formData: {
        id: 0,
        id_code: '',
        name: ''
      },
      list: [],

      socket: '',
      timer: '',
      heartTimer: '',
      lockReconnect: false,
      timeoutObj: null,
      serverTimeoutObj: null,
    }
  },
  filters: {},
  mounted() {
    let that = this;
    // that.formData.id = that.$route.query.id
    // this.fetch();
    document.title="裁判登录"
    that.getScoreList()
    let num = localStorage.getItem('_id_num')
    if(num) {
      that.formData.id_code = num
    }
  },
  watch: {
    keyShow(val)  {
      if(val) {
        window.scrollTo(0,50000);
      } else {
        window.scrollTo(0, 0);
      }
    }
  },
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.post('/api/user/certindex', {}, (res) => {
        that.row = res.data;
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      },2)
    },

    getScoreList() {
      let that = this;
      that.$api.post('/api/dscore/scoreStartList', {}, (res) => {
        that.list = res.data;
      }, (res) => {
      },2)
    },
    onSubmit() {
      let that = this

      if(!that.formData.id_code) {
        Toast('请输入身份证号')
        return
      }

      that.saveLoading = true


      that.$api.post('/api/dscore/caipanLogin', that.formData, (res) => {

        // localStorage.setItem('_id_num', res.data.num);
        localStorage.setItem('_id_num', res.data.num);
        if(res.data.type=='复核'){
          that.list = res.data.sai_list
          that.show= true
        that.saveLoading = false
          return ;
        }
        rbLink({
          name: 'CommonScore'
        });
        Toast.success('登陆成功')
        that.saveLoading = false

      }, (res) => {
        that.saveLoading = false
        Toast(res.msg)
      },2)
    },

    onFocus() {
      this.keyShow = true
      // this.readonly = false
    },

    switchChange(val) {
      let value = val ? 1 :2;
      console.log('switchChange', value)
      localStorage.setItem('_is_local', value);

      // 传递数据给app
      appEvent({
        name: 'postMessage',
        query: {
          value: value
        }
      });
    },

    toCheckLogin() {
      let list = this.list
      if(list.length == 0) {
        Toast.fail('暂无进行中的比赛')
      } else {
        this.show = true
      }
    },

    toScoreCheck(id) {
      rbLink({
        name: 'CommonScoreCheck',
        query: {
          id: id
        }
      });
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// CommonLogin.vue?9ee7155a